module.exports = __webpack_public_path__ + "components/incentive/static/incentive-desktop-b37190993ca25be1140cfa2bfde1ad9f.png";